import { Group, PasswordInput, Popover } from '@mantine/core';
import cx from 'clsx';
import { FC } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { Icon } from 'src/components/Icon';
import { useFormContext } from 'src/form';

import styles from './styles/styles.module.css';
import { usePasswordWithRequirements } from './use-password-with-requirements';

type Props = {
  name: string;
  label: string;
  placeholder: string;
};

export const InputPasswordWithRequirements: FC<Props> = (props) => {
  const { bars, checks, focused, ref, value, setValue } =
    usePasswordWithRequirements();
  const form = useFormContext();

  const { onChange, ...formProps } = form.getInputProps(props.name);

  return (
    <Popover
      classNames={{
        arrow: styles.arrow,
        dropdown: styles.dropdown,
      }}
      position="left"
      width={500}
      withArrow
      opened={focused}
    >
      <Popover.Target>
        <PasswordInput
          value={value}
          ref={ref}
          classNames={{
            innerInput: defaultStyles.innerInput,
            input: defaultStyles.input,
            label: defaultStyles.label,
            root: cx({
              [defaultStyles.root]: true,
              [defaultStyles.rootFocused]: focused,
            }),
            section: styles.section,
            visibilityToggle: styles.toggle,
          }}
          withAsterisk={false}
          visibilityToggleIcon={({ reveal }) => (
            <Icon
              className={cx({
                [styles.iconEye]: true,
                [styles.iconEyeActive]: reveal,
              })}
              name="visibility"
            />
          )}
          onChange={(val) => {
            setValue(val);
            onChange(val);
          }}
          {...props}
          {...formProps}
        />
      </Popover.Target>

      <Popover.Dropdown>
        <Group gap={5} grow mt="xs" mb="md">
          {bars}
        </Group>

        {checks}
      </Popover.Dropdown>
    </Popover>
  );
};
